import { onWatcherCleanup, shallowRef, unref, watch, type Ref } from "vue";

import { debounce } from "@/lib/timing";

export const debouncedRef = <T>(
  source: Ref<T>,
  delay = 500,
  options?: { enabled?: Ref<boolean> }
): Readonly<Ref<T>> => {
  const downstream = shallowRef(undefined as T);

  watch(
    () => unref(options?.enabled) ?? true,
    (isEnabled) => {
      if (!isEnabled) {
        return;
      }

      downstream.value = unref(source);

      onWatcherCleanup(
        watch(
          source,
          debounce((value) => {
            downstream.value = value;
          }, delay)
        )
      );
    },
    { immediate: true }
  );

  return downstream;
};
